// extracted by mini-css-extract-plugin
export default {"closeButton":"mQhdQIdolS8_vTIzQq7R","callout":"geb2hX5dsctKnKgwgXOv"};